import React from 'react';
import './importIcons.js';

import SvgIconMLStyled from './SvgIconMLStyled';

const SvgIconML = (props) => {
  const { name, size, color, style, fill, width, height, ...restProps } = props;
  return (
    <SvgIconMLStyled>
      <svg
        className="icon"
        aria-hidden="true"
        style={Object.assign({}, style, {
          color,
          fill,
          width: width || size + 'px',
          height: height || size + 'px',
        })}
        {...restProps}
      >
        <use xlinkHref={`#${name}`}></use>
      </svg>
    </SvgIconMLStyled>
  );
};
export default SvgIconML;
